module.exports = __webpack_public_path__ + "static/media/spring.d3f4b424.png";